export default __webpack_public_path__ + "static/media/How 1-2.0eac26ba.svg";